module.exports = __webpack_public_path__ + "img/celebrate.cb82c901.gif";